import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, transitions } from '@twistopayments/design-system/styles'

export const root = (theme: Theme) => css`
  background-color: ${theme.palette.background.main};
  border-radius: ${theme.borderRadius.sm};
  box-shadow: ${theme.shadows.box};

  ${breakpoint.up('sm')} {
    border-radius: ${theme.borderRadius.md};
  }
`

export const margin = (theme: Theme) => css`
  margin: ${theme.spacing[8]} 0;

  ${breakpoint.up('sm')} {
    margin: ${theme.spacing[16]} 0;
  }
`

export const padding = (theme: Theme) => css`
  padding: ${theme.spacing[8]};

  ${breakpoint.up('sm')} {
    padding: ${theme.spacing[16]};
  }
`

export const clickable = (theme: Theme) => css`
  cursor: pointer;
  transition: ${transitions.default} box-shadow;

  &:hover,
  &:active {
    box-shadow: ${theme.shadows.boxHover};
  }

  &:focus {
    box-shadow: ${theme.shadows.primaryActive};
  }
`
